module.exports = __webpack_public_path__ + "static/img/cmcc.ce67713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cmcc.png
// module id = kIIe
// module chunks = 40